import { Component, input } from '@angular/core';

// Card used by the redesigned jobseeker profile page and its admin twin
// (jobseeker-profile-for-admin); the shared hrra-jobseeker-profile-tile keeps
// serving customer-app.
@Component({
    selector: 'app-profile-section-tile',
    templateUrl: './profile-section-tile.component.html',
    styleUrls: ['./profile-section-tile.component.scss'],
    standalone: false
})
export class ProfileSectionTileComponent {
  title = input<string>();
  rightText = input<string>();
  // space between the header row and the tile body
  headerSpacing = input<'regular' | 'dense' | 'none'>('regular');
}
